import { HttpService, Repository, RepositoryBase, Tags, Weaver } from '@skylab-shared/core';
import { PurchaseKindModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { PurchaseKindBO } from './purchase-kind.bo';


@Repository({
    boType: PurchaseKindBO,
    apiController: {
        base: 'purchase/kinds/:name',
        tags: [Tags.Api]
    }
})
export class PurchaseKindRepositoryBase extends RepositoryBase<PurchaseKindBO, PurchaseKindModel> {
    public constructor(
        private readonly weaver: Weaver,
        $http: HttpService,
    ) {
        super($http);
    }

    protected createBO(): PurchaseKindBO {
        return new PurchaseKindBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: PurchaseKindModel): Promise<any> {
        return {
            version: model.version,
            name: model.name,
            adjustment: model.adjustment,
            defaultNumberingId: model.defaultNumberingId,
            defaultCalculationMethod: model.defaultCalculationMethod,
            defaultDueDate: model.defaultDueDate
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<PurchaseKindModel> {
        return new PurchaseKindModel(pickBy<PurchaseKindModel>({
            version: item.version,

            name: item.name,
            adjustment: item.adjustment,
            defaultNumberingId: item.defaultNumberingId,
            defaultCalculationMethod: item.defaultCalculationMethod,
            defaultDueDate: item.defaultDueDate
        }, val => val !== void 0));
    }

    //#endregion
}
